import AuthLayout from "@/auth/auth-layout";
import { OtpForm } from "@/auth/otp/components/otp-form";
import { Card } from "@/components/ui/card";

interface OtpProps {
  isSuperadmin: boolean;
}

export default function Otp({ isSuperadmin }: OtpProps) {
  return (
    <AuthLayout>
      <Card className="p-6">
        <div className="mb-2 flex flex-col space-y-2 text-left">
          <h1 className="text-md font-semibold tracking-tight">
            Super Admin 2FA
          </h1>
          <p className="text-muted-foreground text-sm">
            Please enter the authentication code from your authenticator app.
          </p>
        </div>
        <OtpForm isSuperadmin={isSuperadmin} />
        <p className="text-muted-foreground mt-4 px-8 text-center text-sm">
          Contact Ecosuite support if you cannot login.
        </p>
      </Card>
    </AuthLayout>
  );
}
